/**
 * KK Kundeportal Web api
 * v1
 * DO NOT MODIFY - This file has been generated using oazapfts.
 * See https://www.npmjs.com/package/oazapfts
 */
import * as Oazapfts from '@oazapfts/runtime';
import * as QS from '@oazapfts/runtime/query';
export const defaults: Oazapfts.RequestOpts = {
  baseUrl: '/',
};
const oazapfts = Oazapfts.runtime(defaults);
export const servers = {};
export type KeyNumbers = {
  totalOutstandingDebt?: number;
  averageLoanAmount?: number;
  totalLoanCount?: number;
  totalConstructionCreditsCount?: number;
};
export type LoanOverview = {
  contractId?: string | null;
  loanProduct?: ContractLoanTypeEnum;
  greenLoan?: GreenLoanTypeEnum;
  loanName?: string | null;
  principalAmount?: number;
  notionalAmountEOB?: number;
  currency?: CurrencyTypeEnum;
  agreementDate?: string;
  startDate?: string;
  maturityDate?: string;
  interestRate?: number;
  interestConditionExpiryDate?: string;
  interestPaymentFrequency?: DatesPaymentFreqEnum;
  redemptionValueEOB?: number;
  spread?: number;
};
export type LoanDistribution = {
  loanProduct?: ContractLoanTypeEnum;
  value?: number;
  paidValue?: number;
};
export type Customer = {
  fullName?: string | null;
  cpr?: string | null;
  cvr?: string | null;
  cprUuid?: string | null;
  professionalUuidPersistent?: string | null;
  email?: string | null;
  companyName?: string | null;
};
export function getApiKeyNumbers(opts?: Oazapfts.RequestOpts) {
  return oazapfts.ok(
    oazapfts.fetchJson<{
      status: 200;
      data: KeyNumbers;
    }>('/api/KeyNumbers', {
      ...opts,
    }),
  );
}
export function getApiLoanLoans(
  {
    referenceDate,
  }: {
    referenceDate?: string;
  } = {},
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.ok(
    oazapfts.fetchJson<{
      status: 200;
      data: LoanOverview[];
    }>(
      `/api/Loan/Loans${QS.query(
        QS.explode({
          referenceDate,
        }),
      )}`,
      {
        ...opts,
      },
    ),
  );
}
export function getApiLoanLoanDistributions(
  {
    referenceDate,
  }: {
    referenceDate?: string;
  } = {},
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.ok(
    oazapfts.fetchJson<{
      status: 200;
      data: LoanDistribution[];
    }>(
      `/api/Loan/LoanDistributions${QS.query(
        QS.explode({
          referenceDate,
        }),
      )}`,
      {
        ...opts,
      },
    ),
  );
}

export function getApiLoanDownloadLoanOverview(
  {
    referenceDate,
    columnsToInclude,
    downloadType,
  }: {
    referenceDate?: string;
    columnsToInclude?: string[];
    downloadType?: DownloadType;
  } = {},
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.ok(
    oazapfts.fetchText(
      `/api/Loan/DownloadLoanOverview${QS.query(
        QS.explode({
          referenceDate,
          columnsToInclude,
          downloadType,
        }),
      )}`,
      {
        ...opts,
      },
    ),
  );
}
export function postApiLoanUpdateLoanName(
  {
    contractId,
    projectName,
  }: {
    contractId?: string;
    projectName?: string;
  } = {},
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.ok(
    oazapfts.fetchJson<{
      status: 200;
      data: string;
    }>(
      `/api/Loan/UpdateLoanName${QS.query(
        QS.explode({
          contractId,
          projectName,
        }),
      )}`,
      {
        ...opts,
        method: 'POST',
      },
    ),
  );
}
export function getApiNemLoginMetadata(opts?: Oazapfts.RequestOpts) {
  return oazapfts.ok(
    oazapfts.fetchText('/api/NemLogin/metadata', {
      ...opts,
    }),
  );
}
export function getApiNemLoginLogin(
  {
    returnUrl,
  }: {
    returnUrl?: string;
  } = {},
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.ok(
    oazapfts.fetchText(
      `/api/NemLogin/login${QS.query(
        QS.explode({
          returnUrl,
        }),
      )}`,
      {
        ...opts,
      },
    ),
  );
}
export function postApiNemLoginAssertionconsumerservice(
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.ok(
    oazapfts.fetchText('/api/NemLogin/assertionconsumerservice', {
      ...opts,
      method: 'POST',
    }),
  );
}
export function getApiNemLoginLogout(
  {
    returnUrl,
  }: {
    returnUrl?: string;
  } = {},
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.ok(
    oazapfts.fetchText(
      `/api/NemLogin/logout${QS.query(
        QS.explode({
          returnUrl,
        }),
      )}`,
      {
        ...opts,
      },
    ),
  );
}
export function postApiNemLoginLoggedout(opts?: Oazapfts.RequestOpts) {
  return oazapfts.ok(
    oazapfts.fetchText('/api/NemLogin/loggedout', {
      ...opts,
      method: 'POST',
    }),
  );
}
export function postApiNemLoginSinglelogout(opts?: Oazapfts.RequestOpts) {
  return oazapfts.ok(
    oazapfts.fetchText('/api/NemLogin/singlelogout', {
      ...opts,
      method: 'POST',
    }),
  );
}
export function getApiNemLoginMockLogout(opts?: Oazapfts.RequestOpts) {
  return oazapfts.ok(
    oazapfts.fetchText('/api/NemLogin/MockLogout', {
      ...opts,
    }),
  );
}
export function getApiNemLoginMockLogin(opts?: Oazapfts.RequestOpts) {
  return oazapfts.ok(
    oazapfts.fetchText('/api/NemLogin/MockLogin', {
      ...opts,
    }),
  );
}
export function getApiDataProfile(opts?: Oazapfts.RequestOpts) {
  return oazapfts.ok(
    oazapfts.fetchJson<{
      status: 200;
      data: Customer;
    }>('/api/data/Profile', {
      ...opts,
    }),
  );
}
export function getApiDataClaims(opts?: Oazapfts.RequestOpts) {
  return oazapfts.ok(
    oazapfts.fetchJson<{
      status: 200;
      data: string;
    }>('/api/data/Claims', {
      ...opts,
    }),
  );
}
export function getApiDataGetUnprotectedData(opts?: Oazapfts.RequestOpts) {
  return oazapfts.ok(
    oazapfts.fetchJson<{
      status: 200;
      data: string;
    }>('/api/data/GetUnprotectedData', {
      ...opts,
    }),
  );
}
export enum ContractLoanTypeEnum {
  KKvar = 'KKvar',
  KKmax = 'KKmax',
  KKbasis = 'KKbasis',
  KKcibor = 'KKcibor',
  KKcita = 'KKcita',
  KKfast = 'KKfast',
}
export enum GreenLoanTypeEnum {
  Green2017 = 'Green2017',
  Green2022 = 'Green2022',
}
export enum CurrencyTypeEnum {
  Undefined = 'Undefined',
  Aud = 'AUD',
  Cad = 'CAD',
  Chf = 'CHF',
  Dkk = 'DKK',
  Eur = 'EUR',
  Gbp = 'GBP',
  Hkd = 'HKD',
  Jpy = 'JPY',
  Nok = 'NOK',
  Nzd = 'NZD',
  Sek = 'SEK',
  Usd = 'USD',
  Cny = 'CNY',
  Pln = 'PLN',
  Sgd = 'SGD',
  Mxn = 'MXN',
  Zar = 'ZAR',
  Ron = 'RON',
  Huf = 'HUF',
  Try = 'TRY',
  Isk = 'ISK',
  Brl = 'BRL',
  Rub = 'RUB',
  Krw = 'KRW',
  Twd = 'TWD',
  Thb = 'THB',
  Myr = 'MYR',
  Idr = 'IDR',
  Inr = 'INR',
}
export enum DatesPaymentFreqEnum {
  UnDefined = 'UnDefined',
  M1 = 'M1',
  M2 = 'M2',
  M3 = 'M3',
  M4 = 'M4',
  M6 = 'M6',
  M12 = 'M12',
}
export enum DownloadType {
  Csv = 'Csv',
  Pdf = 'Pdf',
}

// #region INJECTED PATHS
/* The generated output is not a direct result of oazapfts' default behavior.
 * It instead incorporates our custom code, which adds path placeholder properties for MSW mocking, into the output of oazapfts. */
// {{{

const _getApiKeyNumbersPath = () => defaults.baseUrl + '/api/KeyNumbers';
Object.defineProperty(getApiKeyNumbers, 'path', {
  get: _getApiKeyNumbersPath,
  set: _getApiKeyNumbersPath,
});
/** @path `/api/KeyNumbers` */
getApiKeyNumbers.path = getApiKeyNumbers.path satisfies string;

const _getApiLoanLoansPath = () => defaults.baseUrl + '/api/Loan/Loans';
Object.defineProperty(getApiLoanLoans, 'path', {
  get: _getApiLoanLoansPath,
  set: _getApiLoanLoansPath,
});
/** @path `/api/Loan/Loans` */
getApiLoanLoans.path = getApiLoanLoans.path satisfies string;

const _getApiLoanLoanDistributionsPath = () =>
  defaults.baseUrl + '/api/Loan/LoanDistributions';
Object.defineProperty(getApiLoanLoanDistributions, 'path', {
  get: _getApiLoanLoanDistributionsPath,
  set: _getApiLoanLoanDistributionsPath,
});
/** @path `/api/Loan/LoanDistributions` */
getApiLoanLoanDistributions.path =
  getApiLoanLoanDistributions.path satisfies string;

const _getApiLoanDownloadLoanOverviewPath = () =>
  defaults.baseUrl + '/api/Loan/DownloadLoanOverview';
Object.defineProperty(getApiLoanDownloadLoanOverview, 'path', {
  get: _getApiLoanDownloadLoanOverviewPath,
  set: _getApiLoanDownloadLoanOverviewPath,
});
/** @path `/api/Loan/DownloadLoanOverview` */
getApiLoanDownloadLoanOverview.path =
  getApiLoanDownloadLoanOverview.path satisfies string;

const _postApiLoanUpdateLoanNamePath = () =>
  defaults.baseUrl + '/api/Loan/UpdateLoanName';
Object.defineProperty(postApiLoanUpdateLoanName, 'path', {
  get: _postApiLoanUpdateLoanNamePath,
  set: _postApiLoanUpdateLoanNamePath,
});
/** @path `/api/Loan/UpdateLoanName` */
postApiLoanUpdateLoanName.path =
  postApiLoanUpdateLoanName.path satisfies string;

const _getApiNemLoginMetadataPath = () =>
  defaults.baseUrl + '/api/NemLogin/metadata';
Object.defineProperty(getApiNemLoginMetadata, 'path', {
  get: _getApiNemLoginMetadataPath,
  set: _getApiNemLoginMetadataPath,
});
/** @path `/api/NemLogin/metadata` */
getApiNemLoginMetadata.path = getApiNemLoginMetadata.path satisfies string;

const _getApiNemLoginLoginPath = () => defaults.baseUrl + '/api/NemLogin/login';
Object.defineProperty(getApiNemLoginLogin, 'path', {
  get: _getApiNemLoginLoginPath,
  set: _getApiNemLoginLoginPath,
});
/** @path `/api/NemLogin/login` */
getApiNemLoginLogin.path = getApiNemLoginLogin.path satisfies string;

const _postApiNemLoginAssertionconsumerservicePath = () =>
  defaults.baseUrl + '/api/NemLogin/assertionconsumerservice';
Object.defineProperty(postApiNemLoginAssertionconsumerservice, 'path', {
  get: _postApiNemLoginAssertionconsumerservicePath,
  set: _postApiNemLoginAssertionconsumerservicePath,
});
/** @path `/api/NemLogin/assertionconsumerservice` */
postApiNemLoginAssertionconsumerservice.path =
  postApiNemLoginAssertionconsumerservice.path satisfies string;

const _getApiNemLoginLogoutPath = () =>
  defaults.baseUrl + '/api/NemLogin/logout';
Object.defineProperty(getApiNemLoginLogout, 'path', {
  get: _getApiNemLoginLogoutPath,
  set: _getApiNemLoginLogoutPath,
});
/** @path `/api/NemLogin/logout` */
getApiNemLoginLogout.path = getApiNemLoginLogout.path satisfies string;

const _postApiNemLoginLoggedoutPath = () =>
  defaults.baseUrl + '/api/NemLogin/loggedout';
Object.defineProperty(postApiNemLoginLoggedout, 'path', {
  get: _postApiNemLoginLoggedoutPath,
  set: _postApiNemLoginLoggedoutPath,
});
/** @path `/api/NemLogin/loggedout` */
postApiNemLoginLoggedout.path = postApiNemLoginLoggedout.path satisfies string;

const _postApiNemLoginSinglelogoutPath = () =>
  defaults.baseUrl + '/api/NemLogin/singlelogout';
Object.defineProperty(postApiNemLoginSinglelogout, 'path', {
  get: _postApiNemLoginSinglelogoutPath,
  set: _postApiNemLoginSinglelogoutPath,
});
/** @path `/api/NemLogin/singlelogout` */
postApiNemLoginSinglelogout.path =
  postApiNemLoginSinglelogout.path satisfies string;

const _getApiNemLoginMockLogoutPath = () =>
  defaults.baseUrl + '/api/NemLogin/MockLogout';
Object.defineProperty(getApiNemLoginMockLogout, 'path', {
  get: _getApiNemLoginMockLogoutPath,
  set: _getApiNemLoginMockLogoutPath,
});
/** @path `/api/NemLogin/MockLogout` */
getApiNemLoginMockLogout.path = getApiNemLoginMockLogout.path satisfies string;

const _getApiNemLoginMockLoginPath = () =>
  defaults.baseUrl + '/api/NemLogin/MockLogin';
Object.defineProperty(getApiNemLoginMockLogin, 'path', {
  get: _getApiNemLoginMockLoginPath,
  set: _getApiNemLoginMockLoginPath,
});
/** @path `/api/NemLogin/MockLogin` */
getApiNemLoginMockLogin.path = getApiNemLoginMockLogin.path satisfies string;

const _getApiDataProfilePath = () => defaults.baseUrl + '/api/data/Profile';
Object.defineProperty(getApiDataProfile, 'path', {
  get: _getApiDataProfilePath,
  set: _getApiDataProfilePath,
});
/** @path `/api/data/Profile` */
getApiDataProfile.path = getApiDataProfile.path satisfies string;

const _getApiDataClaimsPath = () => defaults.baseUrl + '/api/data/Claims';
Object.defineProperty(getApiDataClaims, 'path', {
  get: _getApiDataClaimsPath,
  set: _getApiDataClaimsPath,
});
/** @path `/api/data/Claims` */
getApiDataClaims.path = getApiDataClaims.path satisfies string;

const _getApiDataGetUnprotectedDataPath = () =>
  defaults.baseUrl + '/api/data/GetUnprotectedData';
Object.defineProperty(getApiDataGetUnprotectedData, 'path', {
  get: _getApiDataGetUnprotectedDataPath,
  set: _getApiDataGetUnprotectedDataPath,
});
/** @path `/api/data/GetUnprotectedData` */
getApiDataGetUnprotectedData.path =
  getApiDataGetUnprotectedData.path satisfies string;

// }}}
// #endregion
